import { RowSelectionOptions } from '@ag-grid-community/core';
import { Component } from '@angular/core';
import { Manufacturer, ManufacturerProductTypeConfig } from 'app/model/entities/entity-model';
import { AgFns, ISortModel } from 'app/shared/ag-fns';
import { UniAgFns } from 'app/shared/uni-ag-fns';
import { DbQueryService } from 'app/shared/db-query.service';
import { EntityFinderDialog } from 'app/shared/entity-finder.dialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

export interface ManufacturerProductTypeFinderParams {
  manufacturer: Manufacturer;
  header?: string;
  rowSelection?: RowSelectionOptions; // default is single
}

@Component({
    template: EntityFinderDialog.HTML,
    host: { 'hostID': crypto.randomUUID().toString() },
    standalone: false
})
export class ManufacturerProductTypeFinderDialogComponent extends EntityFinderDialog<ManufacturerProductTypeConfig, ManufacturerProductTypeFinderParams> {

  constructor(
    ref: DynamicDialogRef,
    config: DynamicDialogConfig<ManufacturerProductTypeFinderParams>,
    public dbQueryService: DbQueryService,
  ) {
    super(ref, config);

    Object.assign(this.config, {
      header: this.config.header ?? `Select Manufacture Product Type Config`,
      width: '800px',
      height: '730px',
    });
  }

  override async initDatasource() {
    const q  = this.dbQueryService.createManufacturerProductTypeConfigQuery(this.params.manufacturer.id)
    const ds = AgFns.buildDatasource(() => q);
    return ds;
  }
 
  
  override getColDefsAndSortModel() {
    const colDefs = [

      { headerName: 'Manufacturer', field: 'productType.manufacturer.name',  filter: 'agTextColumnFilter'  },
      { headerName: 'Description', field: 'productType.description', filter: 'agTextColumnFilter' },
      { headerName: 'SKU', field: 'productType.style', filter: 'agTextColumnFilter' },
      { headerName: 'Config Name', field: 'configName', filter: 'agTextColumnFilter' },
      { headerName: 'Config Description', field: 'configDescription', filter: 'agTextColumnFilter' },
      { headerName: 'Id', field: 'id', filter: 'agNumberColumnFilter', maxWidth: 100 },
      UniAgFns.getActiveStatusColDef('activeStatus.name'),
      // Not yet supported.
      // { ...AgFns.createButtonProps('foo', this.onDelete.bind(this), { label: 'Delete', icon: 'delete' }) }
    ]; 
    const sortModel = [
      { colId: 'productType.manufacturer.name', sort: 'asc' },
      { colId: 'productType.description', sort: 'asc' },
      { colId: 'productType.style', sort: 'asc' },
      
    ] as ISortModel;
    return [colDefs, sortModel] as const;
  }


}
